"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLocationName = createLocationName;
exports.generateDefaultHeadshotAltText = generateDefaultHeadshotAltText;
exports.getBookNowPage = getBookNowPage;
exports.getBusinessFile = getBusinessFile;
exports.getBusinessFiles = getBusinessFiles;
exports.getCategoryItems = getCategoryItems;
exports.getCtaInteractions = getCtaInteractions;
exports.getFirstBusinessFile = getFirstBusinessFile;
exports.getLocationTeamMembers = getLocationTeamMembers;
exports.getOtherCategoryItems = getOtherCategoryItems;
exports.getPageByType = getPageByType;
exports.getRelatedCategories = getRelatedCategories;
exports.getServiceItemModifierSets = getServiceItemModifierSets;
exports.getTeamMemberServices = getTeamMemberServices;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _head3 = _interopRequireDefault(require("lodash/head"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _excluded = ["_id", "description", "gatsbyFile", "file"],
  _excluded2 = ["variations", "visible"],
  _excluded3 = ["items"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var EXTERNAL_CLICK_THROUGH_INTERACTION_TYPE = 'EXT_THRU';
function getPageByType() {
  var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var targetPageType = arguments.length > 1 ? arguments[1] : undefined;
  return pages.find(function (_ref) {
    var pageType = _ref.pageType;
    return pageType === targetPageType;
  });
}
function generateDefaultHeadshotAltText(artistName, businessName) {
  return "Portrait of ".concat(artistName, ", a professional stylist at ").concat(businessName, ", showcasing their expertise and style.");
}
function getBookNowPage() {
  var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var regex = /book\s*now|schedule\s*appointment|reserve\s*time/i;
  return pages.find(function (_ref2) {
    var title = _ref2.title,
      pageType = _ref2.pageType;
    return regex.test(title) && pageType === 'External';
  });
}
function getCategoryItems(category) {
  var allItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _ref3 = category || {},
    categoryId = _ref3._id,
    categoryItemIds = _ref3.items;
  return categoryItemIds.filter(function (_ref4) {
    var aCategoryId = _ref4._id;
    return aCategoryId !== categoryId;
  }).map(function (categoryItemId) {
    return allItems.find(function (_ref5) {
      var _id = _ref5._id;
      return _id === categoryItemId;
    });
  }).filter(Boolean);
}
function getOtherCategoryItems(itemId, itemCategory, allItems) {
  if (!itemCategory) {
    return [];
  }
  var _ref6 = itemCategory || {},
    _ref6$items = _ref6.items,
    itemIds = _ref6$items === void 0 ? [] : _ref6$items;
  var otherItemIds = itemIds.filter(function (currentItemId) {
    return currentItemId !== itemId;
  });
  return allItems.filter(function (_ref7) {
    var currentItemId = _ref7._id;
    return otherItemIds.includes(currentItemId);
  }).filter(function (_ref8) {
    var visible = _ref8.visible;
    return !!visible;
  });
}
function getRelatedCategories(category) {
  var allCategories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _ref9 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref9$showAllRelatedS = _ref9.showAllRelatedServices,
    showAllRelatedServices = _ref9$showAllRelatedS === void 0 ? false : _ref9$showAllRelatedS;
  var _ref10 = category || {},
    categoryId = _ref10._id,
    _ref10$schedule = _ref10.schedule,
    schedule = _ref10$schedule === void 0 ? {} : _ref10$schedule;
  var _ref11 = schedule || {},
    scheduleId = _ref11._id;
  return allCategories.filter(function (_ref12) {
    var otherCategoryId = _ref12._id,
      _ref12$schedule = _ref12.schedule,
      otherCategorySchedule = _ref12$schedule === void 0 ? {} : _ref12$schedule;
    if (otherCategoryId === categoryId) {
      return false;
    }
    var _ref13 = otherCategorySchedule || {},
      otherCategoryScheduleId = _ref13._id;
    if (showAllRelatedServices) {
      return true;
    }
    return otherCategoryScheduleId === scheduleId;
  });
}
function getBusinessFiles(businessFileIds) {
  var businessFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return (businessFileIds || []).map(function (objectFileId) {
    var file = businessFiles.find(function (_ref14) {
      var _id = _ref14._id;
      return _id === objectFileId;
    });
    if (file) {
      var _id = file._id,
        description = file.description,
        gatsbyFile = file.gatsbyFile,
        fileUrl = file.file,
        restFile = (0, _objectWithoutProperties2["default"])(file, _excluded);
      return _objectSpread(_objectSpread({}, restFile), {}, {
        _id: _id,
        fileUrl: fileUrl,
        gatsbyFile: gatsbyFile,
        src: gatsbyFile || fileUrl,
        altText: description || ''
      });
    }
    return false;
  }).filter(Boolean);
}
function getBusinessFile(businessFileId) {
  var businessFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var files = getBusinessFiles([businessFileId], businessFiles);
  if (!(0, _isEmpty2["default"])(files)) {
    return files[0];
  }
  return null;
}
function getFirstBusinessFile(businessFileIds) {
  var businessFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var objectFiles = getBusinessFiles(businessFileIds, businessFiles);
  if ((0, _isEmpty2["default"])(objectFiles)) {
    return null;
  }
  return objectFiles[0];
}
function getCtaInteractions(interactions) {
  return (interactions || []).filter(function (_ref15) {
    var behaviorType = _ref15.behaviorType,
      enabled = _ref15.enabled;
    return enabled && behaviorType !== EXTERNAL_CLICK_THROUGH_INTERACTION_TYPE;
  });
}
function getServiceItemModifierSets(item, modifierSets) {
  var modifierSetIds = item.modifierSets;
  if ((0, _isEmpty2["default"])(modifierSetIds)) {
    return [];
  }
  return modifierSetIds.map(function (modifierSetId) {
    return modifierSets.find(function (_ref16) {
      var _id = _ref16._id;
      return _id === modifierSetId;
    });
  }).filter(Boolean);
}
function createLocationName(_ref17) {
  var name = _ref17.name,
    street = _ref17.street,
    city = _ref17.city;
  if (!(0, _isEmpty2["default"])(name)) {
    return name;
  }
  if (!(0, _isEmpty2["default"])(street) && !(0, _isEmpty2["default"])(city)) {
    return "".concat(street, ", ").concat(city);
  }
  return street || city;
}
function getLocationTeamMembers() {
  var teamMembers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var targetLocationId = arguments.length > 1 ? arguments[1] : undefined;
  return teamMembers.filter(function (_ref18) {
    var locations = _ref18.locations;
    return locations.filter(function (_ref19) {
      var location = _ref19.location,
        merchantLocation = _ref19.merchantLocation;
      return targetLocationId === location || targetLocationId === merchantLocation;
    }).length > 0;
  });
}
function getTeamMemberServices() {
  var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var associatedItemVariations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  function getItemIdsWithAssociatedVariations(itemIds) {
    return itemIds.map(function (itemId) {
      var foundAssociation = associatedItemVariations.find(function (_ref20) {
        var aItemId = _ref20.itemId;
        return aItemId === itemId;
      });
      return foundAssociation ? itemId : null;
    }).filter(Boolean);
  }
  function getVariationsForAssociatedItem(associatedItem, variations) {
    return associatedItem.reduce(function (acc, _ref21) {
      var variationId = _ref21.variationId,
        overridePrice = _ref21.price;
      var variationIndex = variations.findIndex(function (_ref22) {
        var _id = _ref22._id;
        return _id === variationId;
      });
      if (variationIndex === -1) {
        return acc;
      }
      var initialPrice = variations[variationIndex].price;
      return [].concat((0, _toConsumableArray2["default"])(acc.slice(0, variationIndex)), [_objectSpread(_objectSpread({}, acc[variationIndex]), {}, {
        price: +overridePrice === 0 || overridePrice === '' ? initialPrice : overridePrice
      })], (0, _toConsumableArray2["default"])(acc.slice(variationIndex + 1)));
    }, variations);
  }
  function consolidateItemVariations(itemIds, associatedItemVariationsMap) {
    return itemIds.map(function (itemId) {
      var associatedItem = associatedItemVariationsMap[itemId];
      if ((0, _isEmpty2["default"])(associatedItem)) {
        return null;
      }
      var _head2 = (0, _head3["default"])(associatedItem),
        item = _head2.item;
      var _item$variations = item.variations,
        variations = _item$variations === void 0 ? [] : _item$variations,
        visible = item.visible,
        restItem = (0, _objectWithoutProperties2["default"])(item, _excluded2);
      if (!visible) {
        return null;
      }
      var nextVariations = getVariationsForAssociatedItem(associatedItem, variations);
      nextVariations = nextVariations.filter(function (_ref23) {
        var currentVariationId = _ref23._id;
        return associatedItem.some(function (_ref24) {
          var variationId = _ref24.variationId;
          return variationId === currentVariationId;
        });
      });
      return _objectSpread(_objectSpread({}, restItem), {}, {
        variations: nextVariations
      });
    }).filter(Boolean);
  }
  return categories.map(function (_ref25) {
    var items = _ref25.items,
      restCategory = (0, _objectWithoutProperties2["default"])(_ref25, _excluded3);
    var itemIdsWithVariationOverrides = getItemIdsWithAssociatedVariations(items);
    var itemVariationOverridesMap = (0, _groupBy2["default"])(associatedItemVariations, 'itemId');
    var itemsWithConsolidatedVariations = consolidateItemVariations(itemIdsWithVariationOverrides, itemVariationOverridesMap);
    if (itemsWithConsolidatedVariations.length === 0) {
      return null;
    }
    return _objectSpread(_objectSpread({}, restCategory), {}, {
      items: itemsWithConsolidatedVariations
    });
  }).filter(Boolean);
}